export const apiPath = '/v1/assets';
const actionType = 'ASSET_RECEIPTS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
